const auth = {
  state: {
    userdata: "the data from auth",
    status: '',
    token: localStorage.getItem('token'),
    permission: [],
    systemSettings: "",
    userInfo: "", 
    projectSelected:{}

  },
  mutations: {
    login(state, payload) {
      state.userdata = payload
    },
    UPDATE_PROJECT(state, payload) {
      state.projectSelected = payload
    },
    logout(state) {
      state.userdata = null
    },
    UPDATE_TOKEN(state, value) {
      state.token = value;
    },
    UPDATE_PERMISSION(state, value) {
      state.permission = value;
    },
    UPDATE_USER_INFO(state, value) {
      state.userInfo = value;
    },
    UPDATE_SYSTEM_SETTINGS(state, value) {
      state.systemSettings = value;
    }
  },
  actions: {
    updateProject({ commit }, token) {    
      commit('UPDATE_PROJECT', token)
    },
    updateToken({ commit }, token) {
      localStorage.setItem('token', token);     
      commit('UPDATE_TOKEN', token)
    },
    updatePermission({ commit }, permission) {
      localStorage.setItem('permission', JSON.stringify(permission));
      commit('UPDATE_PERMISSION', permission); 
    },
    getPermission({ commit }) {
      var permssion = JSON.parse(localStorage.getItem('permission')); 
      commit('UPDATE_PERMISSION', permssion);
      return permssion;
    },
    updateUserInfo({ commit }, payload) {
  
      commit('UPDATE_USER_INFO', payload.data);
      localStorage.setItem('userInfo', JSON.stringify(payload.data));

    },
    updateSystemSettings({ commit }, payload) {
  
      commit('UPDATE_SYSTEM_SETTINGS', payload);
      console.log("settings:",payload);
      localStorage.setItem('systemSettings', JSON.stringify(payload));

    }
 
  },
  getters: {
    getUserData: state => {
      return state.userdata;
    },
    getProjectSelected: state => {
      return state.projectSelected;
    },
    getPermissions: state => {
      if(state.permission==""){
        state.permission = JSON.parse(localStorage.getItem('permission')); 

      } 
      return state.permission;
    },
    
    getSystemSettings: state => {
      if(state.systemSettings==""){
        state.systemSettings = JSON.parse(localStorage.getItem('systemSettings')); 
        console.log("state.systemSettings:",state.systemSettings);
      } 
      return state.systemSettings;
    },

    getUserInfo: state => {
      var userInfo = state.userInfo;
    
      if (userInfo == "") {
        userInfo = localStorage.getItem('userInfo');
        if (userInfo != null && userInfo != '') {
          var userInfo = JSON.parse(userInfo); 
        }
      }

      if (userInfo.hasOwnProperty("branch")) { 
        userInfo.branch = JSON.parse(userInfo.branch);
      }
      if (userInfo.hasOwnProperty("department")) { 
        userInfo.department = JSON.parse(userInfo.department);
      }

      return userInfo;
    }
  },
  namespaced: true,
}

export default auth